import PropTypes from 'prop-types';

export const StopIcon = ({
  width = '24',
  height = '24',
  color = '#F8D72E',
  shouldPadding = false,
  ...props
}) => {
  return (
    <svg
      /* style="color: white" */
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="currentColor"
      className="bi bi-stop-circle"
      viewBox="0 0 16 16"
      style={{
        ...(shouldPadding
          ? {
              padding: '4px',
            }
          : {}),
      }}
      {...props}
    >
      {' '}
      <path
        d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
        fill={color}
      />{' '}
      <path
        d="M5 6.5A1.5 1.5 0 0 1 6.5 5h3A1.5 1.5 0 0 1 11 6.5v3A1.5 1.5 0 0 1 9.5 11h-3A1.5 1.5 0 0 1 5 9.5v-3z"
        fill={color}
      />{' '}
    </svg>
  );
};

StopIcon.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  color: PropTypes.string,
  shouldPadding: PropTypes.bool,
};
